import { userLanguage, ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { AdditionalDocument } from '../../../../types/candidates';
import { successHandler, errorHandler } from '../../../utils';
import {
  AdditionalDocumentBuilder,
  SaveAdditionalDocumentInput,
  SaveAdditionalDocumentOutput,
} from '../additional-document.types';

export const saveAdditionalDocument = (builder: AdditionalDocumentBuilder) =>
  builder.mutation<SaveAdditionalDocumentOutput, SaveAdditionalDocumentInput>({
    query: ({ data }) => {
      return {
        url: '/upload/file/candidate',
        method: 'POST',
        body: data,
      };
    },
    invalidatesTags: [{ type: 'additionalDocuments', id: 'LIST' }],
    transformResponse(resp: AdditionalDocument) {
      if (userLanguage === ValidLanguages.es) {
        successHandler(SuccessMessageEs.AdditionalDocumentSuccess, true);
      } else {
        successHandler(SuccessMessageEn.AdditionalDocumentSuccess, true);
      }

      return resp;
    },
    transformErrorResponse: (error) => {
      errorHandler(
        '[AdditionalDocumentSave]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.AdditionalDocumentError
          : ErrorMessageEn.AdditionalDocumentError,
        error,
        true
      );
    },
  });
